export default {
  empty: 'No results',
  item(data) {
    return JSON.stringify(data, null, 2);
  },
};



// WEBPACK FOOTER //
// ./src/widgets/infinite-hits/defaultTemplates.js